import styled, { css } from 'styled-components';
import { BREAKPOINTS } from '../../../../constants/layout.mjs';
import { theme } from '../../../../constants/theme.mjs';
import { ModalId } from '../../../../contexts/MicrositeMenuContext/types.mjs';
import '../../../Container/index.mjs';
import '../../../StyleableSvgImage/index.mjs';
import { StyleableSvgImage } from '../../../StyleableSvgImage/StyleableSvgImage.mjs';
import { Container as Container$1 } from '../../../Container/Container.mjs';
"use strict";
const FIRST_LEVEL_MENU_HEIGHT = 48;
const Wrap = styled.nav`
  width: 100%;
  height: ${FIRST_LEVEL_MENU_HEIGHT}px;
  padding: 0 16px;
  background: ${theme.colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #ededf0;
  ${({
  $isLastMenu
}) => $isLastMenu && css`
      box-shadow: 0 4px 15px 0 #0000000d;
    `}
`;
const InnerWrap = styled.div`
  width: 100vw;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  height: 100%;
`;
const LeftWrap = styled.div`
  display: flex;
  align-items: center;
`;
const ItemsWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  height: 100%;
`;
const RightWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10.5px;
`;
const ItemLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 7.5px;
`;
const ArrowDownIcon = styled(StyleableSvgImage)``;
const Item = styled.a`
  font-size: 14px;
  text-align: center;
  height: 100%;

  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  /* TODO: Move this to constants */
  color: #212327;

  transition: color 0.2s linear;

  :hover {
    color: ${theme.colors.primaryBlue};
  }

  ${({
  $active
}) => $active && css`
      color: ${theme.colors.primaryBlue};
    `}
`;
const Container = styled(Container$1)`
  @media ${BREAKPOINTS.TOP_NAV_MOBILE_AND_DOWN} {
    padding: 0;
  }
`;
const ModalWrap = styled(Container)`
  flex: 0;
  margin: 0 auto;
  position: relative;
  z-index: ${theme.zIndex.header - 1};
`;
const ActionIcon = styled.div`
  cursor: pointer;
`;
const LogoAnchor = styled.a`
  color: ${theme.colors.menu.text["light"]};
  margin-right: 35px;

  :hover {
    color: ${theme.colors.menu.active["light"]};
  }
`;
const ModalInnerWrap = styled.div`
  position: absolute;
  top: 10px;
  z-index: ${theme.zIndex.modal};

  ${({
  $modal
}) => {
  return $modal === ModalId.Account && css`
        right: 32px;

        @media ${BREAKPOINTS.TOP_NAV_MOBILE_AND_DOWN} {
          right: 10px;
        }
      `;
}}
`;
const Divider = styled.div`
  width: 1px;
  height: 22px;

  background: #00000026;
`;
export { ActionIcon, ArrowDownIcon, Container, Divider, FIRST_LEVEL_MENU_HEIGHT, InnerWrap, Item, ItemLabel, ItemsWrap, LeftWrap, LogoAnchor, ModalInnerWrap, ModalWrap, RightWrap, Wrap };
//# sourceMappingURL=FirstLevelMenu.styles.mjs.map
